const normalizeBaseUrl = (value) => {
    if (!value) {
        return value;
    }
    return value.endsWith('/') ? value.slice(0, -1) : value;
};

const stripVersionSuffix = (value) => {
    if (!value) {
        return value;
    }
    if (value.endsWith('/v1pg')) {
        return value.slice(0, -5);
    }
    if (value.endsWith('/v1')) {
        return value.slice(0, -3);
    }
    return value;
};

const buildDefaultApiRoot = () => {
    if (typeof window !== 'undefined') {
        const { protocol, hostname, port } = window.location;

        if (hostname === 'localhost' || hostname === '127.0.0.1') {
            const defaultPort = '5001';
            const apiPort = process.env.REACT_APP_API_PORT || (port === '3000' ? defaultPort : port || defaultPort);
            return `${protocol}//${hostname}:${apiPort}/api`;
        }

        const targetPort = process.env.REACT_APP_API_PORT || port;
        const portSegment = targetPort ? `:${targetPort}` : '';
        return `${protocol}//${hostname}${portSegment}/api`;
    }

    return 'http://127.0.0.1:5001/api';
};

const envBase = normalizeBaseUrl(process.env.REACT_APP_API_BASE_URL);

export const API_ROOT = stripVersionSuffix(envBase) || buildDefaultApiRoot();

export const API_V1_BASE = `${API_ROOT}/v1`;
export const API_V1PG_BASE = `${API_ROOT}/v1pg`;

export const PAGES = {
    HOME: 'home',
    WIFI: 'wifi',
    CH_UTIL: 'ch-util',
    TX_RX_RETRIES: 'tx-rx-retries',
    USERS: 'users',
    DEVICES: 'devices',
    DEPLOYMENTS: 'deployments',
    WAN: 'wan',
    ALERTS: 'alerts',
    CRASH_REPORT: 'crash-report',
    RESTARTS: 'restarts',
    FCM_MANAGER: 'fcm-manager',
    USER_PREFERENCES: 'user-preferences',
    PREFERENCES: 'preferences',
    APP_METRICS: 'app-metrics',
    NETWORK_DIAGRAM: 'network-diagram',
    STATUS: 'status',
    SETUP_WIZARD: 'setup-wizard',
    MONITOR: 'monitor',
    AI_AGENT: 'diagnostics-ai',
    AGENT_INBOX: 'agent-inbox'
};

export const VIEWS = {
    PLOTS: 'plots',
    TABLES: 'tables'
};

export const INTERVALS = {
    TODAY: 'today',
    YESTERDAY: 'yesterday',
    WEEK: 'week',
    MONTH: 'month',
    CUSTOM: 'custom'
};

export const USER_ROLES = ['admin', 'support', 'viewer', 'mobile'];